export default { options: { label: 'peopleroles' } }
